import apiClient from "./apiClient";
import {
  FilterListRequest,
  FilterListResponse,
} from "./Models/FilterListModel";
import { AxiosResponse } from "axios";

export const getFilterList = async (
  securityToken: string,
  language: string,
  contPubFiltro: boolean
): Promise<FilterListResponse> => {
  const requestData: FilterListRequest = {
    FiltersForPage: 100, // Chiave univoca
    PageRequired: 1, // Chiave da Teamsystem
    SecurityToken: securityToken,
    Language: language,
    ContPubFiltro: contPubFiltro,
  };

  try {
    const response: AxiosResponse<FilterListResponse> = await apiClient({
      method: "post",
      url: "/FilterList/RetrieveUserFilters",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("RetriveFilter Error:", error);
    throw error;
  }
};
